import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";

import Imagen1 from "../../../images/modulo12/cola.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad6.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[7];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[8].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[8].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[6].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[6].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>
              Estela Espinal busca trabajo hace varias semanas, pero no logra
              conseguirlo. En algunos meses nacerá su bebito.
            </li>
            <li>
              Conversa con un amigo, amiga o familiar: ¿por qué crees que Estela
              no consigue trabajo?
            </li>
          </ul>
          <img src={Imagen1} alt="ministerio" className="img-fluid" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique a niños y niñas que en las siguientes actividades
            dialogarán con sus compañeros y compañeras sobre algunas ideas
            acerca del rol de las mujeres que se encuentran arraigadas en las
            personas. Resalte la importancia de sustentar las opiniones.
          </li>
          <li>
            Pida que observen la imagen y que lean la primera indicación: Estela
            Espinal busca trabajo hace varias semanas, pero no logra
            conseguirlo. En algunos meses nacerá su bebito. Lea la segunda
            indicación: Conversa con un amigo, amiga o familiar: ¿por qué crees
            que Estela no consigue trabajo? Mencione que deben trabajar en
            parejas o con un familiar y responder a la pregunta. Déles un tiempo para trabajar.
            Pida algunas de las respuestas. Retómelas y coméntelas. Puede, por
            ejemplo, mencionar lo siguiente:
            <ul>
              <li>
                <i>
                  “El problema que tiene Estela Espinal es muy común en el Perú.
                  Estela no consigue trabajo porque está embarazada. Muchos
                  empleadores consideran que contratar a una mujer que va a ser
                  mamá no es conveniente porque tendrán que pagarle a la
                  trabajadora la licencia de maternidad (los días de descanso
                  antes y después del nacimiento del bebé), que es derecho de
                  toda trabajadora. Esto es discriminatorio hacia las mujeres”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
